import { useQuery } from "@tanstack/react-query";
import { useSelector } from "../../../../../store/store";
import { PlanningDepartmentExportService } from "../../../../../services/planning-department/export-warehouse";

export const useGetMyRequests = () => {
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const response = useQuery({
    queryKey: ["my-requests-export", currentUserName],
    queryFn: () =>
      PlanningDepartmentExportService.getMyRequests({ email: currentUserName }),
      refetchOnMount:"always"
  });

  return response;
};
